// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_ContratoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /contratos/enviar, GET /contratos/atualizar/:id e POST /contratos/cancelar/:id — o contrato como ficou. */
import type { Contratos_ContratoRow } from './Contratos_ContratoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_ContratoResponseDados {
contrato: Contratos_ContratoRow
}

export type Contratos_ContratoResponse = ApiResponse<Contratos_ContratoResponseDados>;

registerResponseContract('Contratos_ContratoResponse', {
  contrato: {
    type: 'object',
    required: true,
    fields: {
      id:              { type: 'number',  required: true },
      franquia_id:     { type: 'number',  required: true },
      modelo_versao:   { type: 'number',  required: true },
      situacao:        { type: 'string',  required: true },
      franqueado_nome: { type: 'string',  required: false },
      signatarios: {
        type: 'array',
        required: false,
        items: {
          papel:       { type: 'string',  required: false },
          nome:        { type: 'string',  required: false },
          email:       { type: 'string',  required: false },
          situacao:    { type: 'string',  required: false },
          assinado_em: { type: 'string',  required: false },
        },
      },
      enviado_por:     { type: 'string',  required: false },
      enviado_em:      { type: 'string',  required: true },
      concluido_em:    { type: 'string',  required: false },
      tem_assinado:    { type: 'boolean', required: false },
      tem_certificado: { type: 'boolean', required: false },
    },
  },
})
